import { Heading } from '@fourthwall/components';
import React from 'react';
import * as S from './Incentive.styled';
export const Incentive = () => (React.createElement(S.Container, null,
    React.createElement(S.Subtitle, null, "Recommended"),
    React.createElement(Heading, { asTag: "h4", type: "h7", weight: "semibold" }, "Add a video or audio message"),
    React.createElement(S.Paragraph, null, "Increase engagement by adding a video or audio message!")));
